import * as React from 'react'
import { formatShortDate } from './dateHelper'
import { regexInitials } from './regexHelper'
import { ICoreColumn } from '../components/DetailsList/DetailsListAbstract'
import PersonAvatar from '../components/PersonAvatar'

type Settings = Partial<ICoreColumn> & Pick<ICoreColumn, 'key'>

export function shortDateColumn(settings: Settings): ICoreColumn {
    const fieldName = settings.fieldName || settings.key
    return {
        name: 'Datum',
        iconName: 'Calendar',
        isSortable: true,
        minWidth: 40,
        maxWidth: 40,
        isResizable: false,
        isIconOnly: true,
        className: 'ms-textAlignRight',
        headerClassName: 'align-center',
        onRender: item => (item[fieldName] ? formatShortDate(item[fieldName]) : ''),
        ...settings,
        fieldName,
    }
}

export function personaColumn(settings: Settings): ICoreColumn {
    const fieldName = settings.fieldName || settings.key
    return {
        name: 'Uitvoerder',
        iconName: 'AccountManagement',
        minWidth: 32,
        maxWidth: 32,
        isResizable: false,
        isIconOnly: true,
        isSortable: true,
        isCollapsible: true,
        className: 'persona',
        headerClassName: 'align-center',
        iconClassName: 'align-center',
        // Get the first letter of each word in order to enable sorting on initials.
        data: item => regexInitials(item[fieldName].fullName),
        onRender: item =>
            item[fieldName] && <PersonAvatar key={`persona-${fieldName}`} name={item[fieldName].fullName} color={'colorful'} size={24} />,
        ...settings,
        fieldName,
    }
}
